import { useEffect, useState } from "react";
import IMG from "../../assets/img/Img";
import { useGraphqlService } from "../service/GraphqlService";
import { queryBuilder } from "../service/QueryBuilder";
import { InfoText } from "../tag/CustomTag";

export const TreeMenu = ({ theme, selectParentMenu, onSelectParentMenu }) => {
    // const menu = {
    //     NO: 1,
    //     MENU_NAME: "시스템",
    //     CHILD: [
    //         {
    //             NO: 2,
    //             MENU_NAME: "관리자",
    //             CHILD: [
    //                 {
    //                     NO: 4,
    //                     MENU_NAME: "대시보드"
    //                 },
    //                 {
    //                     NO: 5,
    //                     MENU_NAME: "메뉴관리"
    //                 }
    //             ]
    //         },
    //         {
    //             NO: 3,
    //             MENU_NAME: "사용자",
    //             CHILD: []
    //         }
    //     ]
    // };

    const { executeQuery } = useGraphqlService();
    const [menu, setMenu] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const { data } = await executeQuery(
                queryBuilder(true, true, { info: 'menu' })
            );

            if(data){
                setMenu(data.getMenuList);
                console.log(data.getMenuList)
            }            
        };
        fetchData();
    }, [executeQuery]);

    return (
        // <div className="w-full">
        //     <ul>
        //         <TreeItem
        //             menu={menu}
        //             depth={0}
        //             selectParentMenu={selectParentMenu}
        //             onSelectParentMenu={onSelectParentMenu}
        //             theme={theme}
        //         />
        //     </ul>
        // </div>  
        <></>
    );
};

const TreeItem = ({
    menu,
    depth = 0,
    parentMenu = null,
    selectParentMenu,
    onSelectParentMenu,
    theme
}) => {
    const [open, setOpen] = useState(true);
    const hasCHILD = menu.CHILD && menu.CHILD.length > 0;

    return (
        menu.length > 0 ?
            <>
                <li className={`pl-[${depth * 12}px]`}>
                    <div className="flex items-center gap-1">
                        {hasCHILD ? (
                            <img
                                onClick={() => setOpen(!open)}
                                className={`w-[1rem] transition-transform duration-200 cursor-pointer ${open ? "rotate-90" : ""
                                    }`}
                                src={IMG.CHEVRON_RIGHT_ICON}
                                alt=""
                            />
                        ) : <div className="w-[1rem]"></div>}

                        <span
                            onClick={() => onSelectParentMenu(menu, parentMenu)}
                            className={`cursor-pointer text-${theme}`}
                        >
                            {menu.MENU_NAME}
                        </span>

                        {selectParentMenu?.NO === menu.NO && (
                            <img
                                className="w-[1.1rem] ml-1"
                                src={IMG.CHECK_ICON}
                                alt=""
                            />
                        )}
                    </div>

                    {open && hasCHILD && (
                        <ul>
                            {menu.CHILD.map((subMenu, index) => (
                                <TreeItem
                                    key={index}
                                    menu={subMenu}
                                    depth={depth + 1}
                                    parentMenu={menu}
                                    selectParentMenu={selectParentMenu}
                                    onSelectParentMenu={onSelectParentMenu}
                                    theme={theme}
                                />
                            ))}
                        </ul>
                    )}
                </li>
            </> : <InfoText>메뉴 데이터가 없습니다</InfoText>
    );
};